import { Limit_Time_Period } from '@occc/graphql';

type TimePeriodMap = {
  [key in Limit_Time_Period]: string;
};

type FormatLimitFn = (params: { limit: number; timePeriod?: Limit_Time_Period }) => string;

export type LimitCategory = 'fulfillment' | 'progress' | 'transaction';

export type LimitConfig = {
  label: string;
  format: FormatLimitFn;
  category: LimitCategory;
};

export const timePeriodMap: TimePeriodMap = {
  [Limit_Time_Period.Day]: 'day',
  [Limit_Time_Period.Week]: 'week',
  [Limit_Time_Period.Month]: 'month',
};

const formatActivationLimitInTime: FormatLimitFn = ({ limit, timePeriod }) =>
  `${limit} activations per ${timePeriodMap[timePeriod!]}`;
const formatAwardLimitInTime: FormatLimitFn = ({ limit, timePeriod }) =>
  `${limit} fulfillments per ${timePeriodMap[timePeriod!]}`;
const formatActivationLimit: FormatLimitFn = ({ limit }) => `${limit} activations`;
const formatAwardLimit: FormatLimitFn = ({ limit }) => `${limit} fulfillments`;
const formatProgressPerTransaction: FormatLimitFn = ({ limit }) => `${limit} per transaction`;
const formatProgressPerPeriod: FormatLimitFn = ({ limit, timePeriod }) =>
  `${limit} per ${timePeriodMap[timePeriod!]}`;
const formatTransactionCountTotal: FormatLimitFn = ({ limit }) => `${limit} transactions total`;
const formatTransactionCountInTime: FormatLimitFn = ({ limit, timePeriod }) =>
  `${limit} transactions per ${timePeriodMap[timePeriod!]}`;

export const limitConfigMap: Record<string, LimitConfig> = {
  LimitGlobalActivation: {
    label: 'Global Activation Limit',
    format: formatActivationLimit,
    category: 'fulfillment',
  },
  LimitGlobalActivationInTime: {
    label: 'Global Activation Limit',
    format: formatActivationLimitInTime,
    category: 'fulfillment',
  },
  LimitMembershipActivation: {
    label: 'Per Member Activation Limit',
    format: formatActivationLimit,
    category: 'fulfillment',
  },
  LimitMembershipActivationInTime: {
    label: 'Per Member Activation Limit',
    format: formatActivationLimitInTime,
    category: 'fulfillment',
  },
  LimitGlobalAwardCount: {
    label: 'Global Fulfillment Limit',
    format: formatAwardLimit,
    category: 'fulfillment',
  },
  LimitGlobalAwardCountInTime: {
    label: 'Global Fulfillment Limit',
    format: formatAwardLimitInTime,
    category: 'fulfillment',
  },
  LimitMembershipAwardCount: {
    label: 'Per Member Fulfillment Limit',
    format: formatAwardLimit,
    category: 'fulfillment',
  },
  LimitMembershipAwardCountInTime: {
    label: 'Per Member Fulfillment Limit',
    format: formatAwardLimitInTime,
    category: 'fulfillment',
  },
  LimitInTransactionAwardCount: {
    label: 'Per Transaction Fulfillment Limit',
    format: formatAwardLimit,
    category: 'fulfillment',
  },
  LimitInTransactionProgress: {
    label: 'Progress Limit Per Transaction',
    format: formatProgressPerTransaction,
    category: 'progress',
  },
  LimitMembershipProgressInTime: {
    label: 'Progress Limit Per Period',
    format: formatProgressPerPeriod,
    category: 'progress',
  },
  LimitMembershipTransactionCount: {
    label: 'Transaction Frequency Limit',
    format: formatTransactionCountTotal,
    category: 'transaction',
  },
  LimitMembershipTransactionCountInTime: {
    label: 'Transaction Frequency Limit',
    format: formatTransactionCountInTime,
    category: 'transaction',
  },
};
